import type { CSSProperties } from "react";
import "./studio-skeleton-block.css";

export type StudioSkeletonBlockRounded = "pill" | "card" | "circle" | "row";

export function StudioSkeletonBlock({
  className = "",
  style,
  rounded = "row",
}: {
  className?: string;
  style?: CSSProperties;
  rounded?: StudioSkeletonBlockRounded;
}) {
  const roundClass =
    rounded === "pill"
      ? "is-pill"
      : rounded === "card"
        ? "is-card"
        : rounded === "circle"
          ? "is-circle"
          : "is-row";
  return (
    <span
      className={`studio-skeleton-block ${roundClass}${className ? ` ${className}` : ""}`}
      style={style}
      aria-hidden="true"
    />
  );
}
